import { toast } from "react-toastify";
import axios from "axios";
//Development
const mode = process.env.REACT_APP_MODE;
const requestControllers = new Map<string, AbortController>();

const BASE_URL =
  mode === "DEVELOPMENT"
    ? process.env.REACT_APP_DEV_BASE_URL
    : process.env.REACT_APP_BASE_URL;

// Parent domain to share the user_id cookie across subdomains (e.g.
// "xxdomain.com" so app.xxdomain.com AND xxdomain.com/WordPress can read it).
// Leave empty in local dev so the cookie stays host-only (localhost).
const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || "";
// const BASE_URL = "http://127.0.0.1:8000/api/";

interface PropData {
  action: string;
  method?: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
  _file?: File;
  key?: string;
  type?: string;
}

const WebService = {
  CommonApi: function (props: PropData) {
    return new Promise((resolve, reject) => {
      let bodyFormData: any = null;

      if (props.isFormData) {
        bodyFormData = new URLSearchParams();
        for (let key in props.body) {
          bodyFormData.append(key, props.body[key]);
        }
      }

      const headers: any = {
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",

        "x-info-id": localStorage.getItem("x-info-id"),
      };

      // Only add Content-Type for non-GET requests
      if (props.method !== "GET") {
        headers["Content-Type"] = props.isFormData
          ? "application/x-www-form-urlencoded"
          : "application/json";
      }

      const handleResponse = (response: any) => resolve(response.data);
      const handleError = (error: any) => {
        if (error?.response?.status === 401) {
          this.logout();
        }
        props.isShowError ? reject(this.errorHandler(error)) : reject(error);
      };
      const requestConfig: any = { headers };
      switch (props.method) {
        case "POST":
          axios
            .post(
              `${BASE_URL}${props.action}`,
              props.isFormData ? bodyFormData : props.body,
              requestConfig,
            )
            .then(handleResponse)
            .catch(handleError);
          break;
        case "PUT":
          axios
            .put(`${BASE_URL}${props.action}`, props.body, requestConfig)
            .then(handleResponse)
            .catch(handleError);
          break;
        case "GET":
          if (props.body && Object.keys(props.body).length > 0) {
            requestConfig["params"] = props.body;
          }
          axios
            .get(`${BASE_URL}${props.action}`, requestConfig)
            .then(handleResponse)
            .catch(handleError);
          break;
        case "DELETE":
          axios
            .delete(`${BASE_URL}${props.action}`, {
              ...requestConfig,
              data: props.body,
            })
            .then(handleResponse)
            .catch(handleError);
          break;
        default:
          reject(new Error("Invalid method"));
      }
    });
  },

  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const isFormDataInstance = typeof FormData !== "undefined" && props.body instanceof FormData;
      var bodyFormData = new URLSearchParams();
      if (!isFormDataInstance && props.isFormData) {
        for (let key in props.body) {
          bodyFormData.append(key, props.body[key]);
        }
      }
      const headers: any = {
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      if (!isFormDataInstance) {
        headers["Content-Type"] = props.isFormData
          ? "application/x-www-form-urlencoded"
          : "application/json";
      }
      axios
        .post(
          `${BASE_URL}${props.action}`,
          isFormDataInstance ? props.body : (props.isFormData ? bodyFormData : props.body),
          {
            headers: headers,
          },
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  uploadAPI: function (props: PropData) {
    const isFormDataInstance = typeof FormData !== "undefined" && props.body instanceof FormData;
    let formData = isFormDataInstance ? props.body : new FormData();
    if (!isFormDataInstance) {
      if (props._file && props.key) {
        if (props.type) {
          formData.append(props.key, props._file, props.type);
        } else if ((props._file as any)?.name) {
          formData.append(props.key, props._file, (props._file as any).name);
        } else {
          formData.append(props.key, props._file);
        }
      }
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
    }
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, formData, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  getRequestKey(action: string) {
    return action.split("?")[0];
  },
  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {

      const headers = {
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      const config: any = this.getRequestConfig(this.getRequestKey(props.action), headers);

      if (props.body && Object.keys(props.body).length > 0) {
        config["params"] = props.body;
      }
      axios
        .get(`${BASE_URL}${props.action}`, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (
            error?.code === "ERR_CANCELED" ||
            error?.name === "CanceledError"
          ) {
            return;
          }

          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  // Authenticated binary download (e.g. PDF). Resolves with the full axios
  // response so callers can read both the blob and headers (filename).
  downloadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      axios
        .get(`${BASE_URL}${props.action}`, {
          headers: headers,
          responseType: "blob",
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  beforeLogingetAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .get(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          localStorage.getItem("access_token") &&
            localStorage.getItem("access_token") != ""
            ? "Bearer " + localStorage.getItem("access_token")
            : "",
        "x-info-id": localStorage.getItem("x-info-id"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.logout();
          }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    if (error?.response) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      setTimeout(() => {
        this.logout();
      }, 500);
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.message;
    }
    toast.error(errorMessage);
    return errorMessage;
  },
  beforeLoginPostAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      let bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          },
        )
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          if (props.isShowError) {
            reject(this.errorHandler(error));
          } else {
            // toast.error("Invalid details");
            reject(error);
          }
        });
    });
  },
  addLoader(id?: string) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = true;
    button.style.position = "relative"; // make button the positioning context

    // Create loader wrapper
    const loader = document.createElement("span");
    loader.className = "button-loader";
    loader.innerHTML = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  `;

    // Style loader to center it
    Object.assign(loader.style, {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-70%, -70%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      color: "#ffff",
    });

    button.appendChild(loader);
  },

  removeLoader(id: any) {
    if (!id) return;

    const button = document.getElementById(id) as HTMLButtonElement | null;
    if (!button) return;

    button.disabled = false;

    // Find the loader element we added
    const loader = button.querySelector(".button-loader");
    if (loader) {
      button.removeChild(loader);
    }
  },

  cookieAttributes() {
    const parts = ["path=/", "SameSite=Lax"];
    if (COOKIE_DOMAIN) {
      parts.push(`domain=${COOKIE_DOMAIN}`);
      parts.push("Secure");
    }
    return parts.join("; ");
  },

  setUserIdCookie(id: any) {
    document.cookie = `user_id=${id ?? ""}; ${this.cookieAttributes()}; max-age=2592000`;
  },

  logout() {
    console.log("Inside logout");

    let loginRoute = "/";
    try {
      const persistRoot = localStorage.getItem("persist:root");
      if (persistRoot) {
        const parsedRoot = JSON.parse(persistRoot);
        if (parsedRoot && parsedRoot.items) {
          const items = JSON.parse(parsedRoot.items);
          const activeLogin = items.storeActiveLoginType;
          if (activeLogin && activeLogin.loginType) {
            const lType = activeLogin.loginType.toLowerCase();
            const aType = activeLogin.account_type ? activeLogin.account_type.toLowerCase() : "";
            
            if (lType === "entrepreneur" && aType) {
              loginRoute = `/${lType}/${aType}/login`;
            } else if (lType === "investor" || lType === "mentor") {
              loginRoute = `/${lType}/login`;
            }
          }
        }
      }
    } catch (e) {
      console.error("Error reading login route for logout", e);
    }

    localStorage.clear();

    document.cookie = `user_id=; ${this.cookieAttributes()}; max-age=0`;

    console.log("Redirecting to", loginRoute);

    window.location.replace(loginRoute);
  },


  getRequestConfig(action: string, headers: any) {

    if (requestControllers.has(action)) {
      requestControllers.get(action)?.abort();
    }

    const controller = new AbortController();
    requestControllers.set(action, controller);

    return {
      headers,
      signal: controller.signal,
    };
  }
};

export default WebService;
